<template lang="pug">
    Tabs.category
        template(v-if="!(error && [401, 403].includes(error.code))" slot="tabbar-buttons")
            el-button(
                circle v-if="! loading"
                type="success"
                icon="el-icon-fa-save fas"
                :disabled="isDisabledSubmit"
                :loading="saving"
                @click="submit"
            )
            //- workaround
            .hidden {{ loading }}

        el-form(label-position="top" :model="form" :rules="rules" ref="form")
            el-card(shadow="always" v-loading="loading")
                .error(v-if="error")
                    template(v-if="error.code")
                        Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
                    template(v-else)
                        Error(:message="$t('Something went wrong!')" :code="501")
                .empty-category(v-else-if="! form.categories.length")
                    el-alert(type="info" :title="$t('This shop has no categories yet')" :closable="false")
                    el-button.add-first-category(
                        type="primary"
                        size="mini"
                        icon="el-icon-fa-plus fas"
                        @click="openNewCategoryModal"
                    ) {{ $t('Add Category') }}
                .categories(v-else)
                    .tree(:class="{ 'no-collapsables': !collapsables.length }")
                        .context-icon
                            i.el-icon-fa-tags.fas
                            small {{ $t('Shop Categories') }}
                        el-button.add-item(
                            type="primary"
                            size="small"
                            icon="el-icon-fa-plus fas"
                            @click="openNewCategoryModal"
                        ) {{ $t('Add Category') }}
                        el-button-group(v-if="collapsables.length")
                            el-button.expand-all(
                                @click="forceExpandAll"
                                :type="ui.expandAll ? 'primary' : 'default'"
                                size="mini"
                            ) {{ $t('Expand all') }}
                            el-button.collapse-all(
                                @click="forceCollapseAll"
                                :type="ui.expandAll ? 'default' : 'primary'"
                                size="mini"
                            ) {{ $t('Collapse all') }}

                        //- Categories

                        el-tree(
                            ref="tree"
                            :key="`${currentCategory ? currentCategory.id : 'new'}-${uniqid}-${ui.expandAll}`"
                            :data="tree"
                            :props="treeProps"
                            :default-expand-all="ui.expandAll"
                            :expand-on-click-node="false"
                            :default-expanded-keys="expandedKeys"
                            :current-node-key="currentCategory ? currentCategory.id : null"
                            :highlight-current="true"
                            :check-on-click-node="false"
                            :show-checkbox="false"
                            :check-strictly="true"
                            :empty-text="$t('This shop has no categories yet')"
                            node-key="id"
                            :allow-drag="isDraggable"
                            @current-change="changeCurrentCategory"
                            @node-drop="moveTreeItem"
                            draggable
                        )
                            span.custom-tree-node.el-tree-node__label(
                                slot-scope="{ node, data }"
                                :class="{ disabled: data.status === 'disabled' || hasDisabledAncestor(data), orphan: isOrphan(data) }"
                            )

                                span.buttons.before(:class="{ 'no-expandables': !collapsables.length }")
                                    el-button.info.expandable(
                                        v-if="node.childNodes && node.childNodes.length"
                                        size="mini"
                                        type="text"
                                        @click.stop="toggleExpand(node)"
                                    )
                                        //- .el-icon-fa-check-circle.far
                                        i(v-if="!collapsables.includes(data.id)")
                                        i(v-else-if="node.expanded").el-icon-fa-chevron-down.fas
                                        i(v-else).el-icon-fa-chevron-right.fas

                                strike.grow(v-if="data.deleted || hasDeletedAncestor(data) ")
                                    | {{ $t(data.name) }}
                                span.grow(v-else) {{ $t(data.name) }}

                                //- span {{ data._lft }} {{ data._rgt }}
                                span.buttons.after
                                    //- el-button.info.toggle-visibility(
                                    //-     v-if="data.hidden"
                                    //-     size="mini"
                                    //-     type="text"
                                    //-     @click.stop="unhideCategory(data)"
                                    //- )
                                    //-     i.el-icon-fa-eye-slash.far
                                    //- el-button.info.toggle-visibility(
                                    //-     v-else
                                    //-     size="mini"
                                    //-     type="text"
                                    //-     @click.stop="hideCategory(data)"
                                    //- )
                                    //-     i.el-icon-fa-eye.far
                                    template(v-if="isDeletable(data)")
                                        template(v-if="data.deleted")
                                            el-button.success(
                                                size="mini"
                                                type="text"
                                                @click.stop="restoreCategory(data)"
                                            )
                                                i.el-icon-fa-trash-restore.fas
                                        template(v-else-if="hasDeletedAncestor(data)")
                                            el-button.info(
                                                size="mini"
                                                type="text"
                                                disabled
                                            )
                                                i.el-icon-fa-trash-alt.far
                                        template(v-else)
                                            el-button.danger(
                                                size="mini"
                                                type="text"
                                                @click.stop="removeCategory(data)"
                                            )
                                                i.el-icon-fa-trash-alt.fas

                    .content
                        router-view.category-form(v-if="currentCategory" :key="$route.path" :class="{'loading-panel': loading}")
                        el-alert(v-else type="info" :title="$t('No category selected!')" :closable="false")

            .form-buttons(v-if="!(error && [401, 403].includes(error.code))")
                el-button(
                    round v-if="! loading"
                    type="success"
                    icon="el-icon-fa-save fas"
                    :loading="saving"
                    :disabled="isDisabledSubmit"
                    @click="submit"
                ) {{ $t('Save') }}

        el-dialog.new-category-dialog(
            :title="$t('Add Category')"
            :visible.sync="newCategoryModalVisibility"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            top="10vh"
            width="90%"
            @closed="resetNewCategoryModal"
        )
            el-form.property-modal-form(
                ref="newCategoryForm"
                :model="newCategoryForm"
                label-position="top"
                :rules="newCategoryRules"
                v-loading="newCategoryModalLoading"
                @submit.prevent.native="appendCategory"
            )
                transition(name="slide-vertical")
                    div.modal-body(v-if="! newCategoryModalLoading")
                        el-row.no-margin(:gutter="20")
                            el-col(:sm="12")
                                el-form-item(:label="$t('Name')" prop="data.name")
                                    el-input(v-model="newCategoryForm.data.name" autocomplete="off" v-focus maxlength="255" show-word-limit)
                            el-col(:sm="12")
                                el-form-item(:label="$t('Key')" prop="data.key")
                                    el-input(v-model="newCategoryForm.data.key" autocomplete="off" maxlength="255" show-word-limit)
                        el-form-item(v-if="tree.length" :label="$t('Position')" prop="position")
                            .target-position
                                .position
                                    el-switch(
                                        active-color="$--color-primary"
                                        inactive-color="$--color-primary"
                                        :active-text="$t('into')"
                                        :inactive-text="$t('under')"
                                        active-value="into"
                                        inactive-value="after"
                                        v-model="newCategoryForm.position"
                                    )
                                .target
                                    Treeselect(
                                        v-model="newCategoryForm.target"
                                        placeholder=""
                                        :multiple="false"
                                        :options="tree"
                                        :default-expand-level="ui.expandAll ? Infinity : 0"
                                        :close-on-select="true"
                                        :open-on-focus="true"
                                        :searchable="false"
                                        :clearable="false"
                                        :always-open="false"
                                    )
                                        label(
                                            slot="option-label"
                                            slot-scope="{ node }"
                                        ) {{ node.raw.name }}
                                        div(
                                            slot="value-label"
                                            slot-scope="{ node }"
                                        ) {{ node.raw.name }}

            template(slot="footer")
                el-button(
                    size="mini"
                    icon="el-icon-fa-times fas"
                    @click="closeNewCategoryModal"
                ) {{ $t('Dismiss') }}
                el-button(
                    :disabled="newCategoryModalLoading"
                    size="mini"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    @click="appendCategory"
                ) {{ $t('Ok') }}
</template>

<i18n>
{
    "de": {
        "Shop Categories": "Shop-Kategorien",
        "Category Not Found": "Kategorie konnte nicht gefunden werden.",
        "Expand all": "aufklappen",
        "Collapse all": "zuklappen",
        "Something went wrong!": "Etwas ist schiefgelaufen!",
        "Category could not be fetched.": "Kategorie konnte nicht abgerufen werden.",
        "This shop has no categories yet": "Dieser Shop hat noch keine Kategorien",
        "Add Category": "Kategorie hinzufügen",
        "Position": "Position",
        "under": "unter",
        "into": "in",
        "Key": "Eindeutige Kennung",
        "URL": "URL",
        "Orphans": "Waisen",
        "Category dependencies could not be fetched.": "Kategorieabhängigkeiten konnten nicht abgerufen werden.",
        "No category selected!": "Keine Kategorie ausgewählt!",
        "Categories could not be saved.": "Kategorien konnten nicht gespeichert werden.",
        "Categories saved successfully!": "Kategorien erfolgreich gespeichert!"
    }
}
</i18n>

<script>
import _ from 'lodash';
// import Vue from 'vue'
import uniqid from 'uniqid';
import { mapMutations, mapActions, mapGetters } from 'vuex';

import NestedSet from '@/nested-set-lib';
// import MenuApi from '@/store/api/cms/menu'

import router from '@/router';
import store from '@/store';

import Tabs from '@/extensions/shop/views/Partials/CatalogTabs';
import Error from '@/components/Error';

import Treeselect from '@riophae/vue-treeselect';

export default {
    name: 'CategoryForm',
    data() {
        return {
            error: false,
            // loading: false,
            saving: false,

            newCategoryModalVisibility: false,
            newCategoryModalLoading: false,
            expandedKeys: [],
            uniqid: uniqid(), // reload tree
            treeProps: {
                label: 'title',
                disabled: 'deleted'
            },
            newCategoryForm: {
                data: {
                    name: '',
                    key: ''
                    // status: false,
                },
                position: 'after',
                target: null
            }
        };
    },
    components: {
        Tabs,
        Error,
        Treeselect
    },
    watch: {
        'ui.expandAll': function(expand) {
            if (!expand) {
                this.expandedKeys = [];
                this.expandAncestorCategories(this.$route.params.id);
            }
            this.uniqid = uniqid(); // reload tree
        },
        'newCategoryForm.data.name': function(value) {
            if (!value) {
                // || _.get(this.newCategoryForm, 'type.key') === 'Redirect'
                this.newCategoryForm.data.key = '';
                return;
            }

            const requestedKey = _.kebabCase(value);
            let key = requestedKey;

            var i = 0;
            while (this.usedKeys.indexOf(`${key}`) >= 0) {
                ++i;
                key = `${requestedKey}-${i}`;
            }

            this.newCategoryForm.data.key = `${key}`;
        },
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) {
                this.setInitializedFlag(false);
                this.initialize();
            }
        }
    },
    computed: {
        // id() {
        //     return _.get(this.form, 'id', false)
        // },
        isDisabledSubmit() {
            return this.saving;
        },
        // key() {
        //     return this.$route.params.key
        // },
        // activeTab() {
        //     // let tab = this.$route.fullPath
        //     // if (this.$route.name !== 'menu-form') {
        //     //     const route = this.$route.matched.find(route => route.name === 'menu-form')
        //     //     if (route) tab = route.path.replace(':key?', this.key)
        //     // }
        //     // return tab
        //
        //     return `/menu/${this.key}`
        // },
        tree() {
            let items = _.get(this.form, 'categories') || [];
            items = _.cloneDeep(items);

            let tree = NestedSet.createTree(items);
            // if (tree.length) tree = [{ name: 'foo' }, ...tree]
            return tree;
        },
        currentCategory() {
            const categories = _.get(this.form, 'categories') || [];
            const currentID = _.get(this.$route, 'params.id');

            if (categories.length && currentID) {
                const item = categories.find(item => item.id.toString() === currentID.toString());
                if (item) return item;
                else {
                    // this.$notify.error({
                    //     title: this.$t('An error occurred!'),
                    //     message: this.$t('Category could not be found.'),
                    //     iconClass: 'fas el-icon-fa-xmark',
                    //     position: 'bottom-left',
                    //     customClass: 'dark',
                    //     duration: 8000,
                    // })

                    const id = categories[0].id;
                    const route = router.history.current.matched.find(
                        route => route.components.default.name === 'category-form'
                    );

                    if (route && id) {
                        router.replace(`${route.path}`);
                    }

                    return null;
                }
            } else {
                return null;
            }
        },
        newCategoryRules() {
            return {
                data: {
                    name: 'required',
                    key: `required|key|excluded:${this.usedKeys.join(',')}`
                }
            };
        },
        usedKeys() {
            let usedKeys = _.cloneDeep(this.validation.usedKeys);
            this.form.categories.forEach(item => usedKeys.push(item.key));

            return usedKeys;
        },
        collapsables() {
            // get all nodes with children
            // except for the ancestors of the current item

            const items = _.get(this.form, 'categories') || [];
            let collapsables = items.filter(el => el._rgt - el._lft > 1);

            if (this.$route.params.id) {
                const item = items.find(el => el.id.toString() === this.$route.params.id.toString());
                if (item) {
                    const ancestors = NestedSet.getAncestors(items, item).map(el => el.id);
                    if (ancestors.length) {
                        collapsables = collapsables.filter(el => !ancestors.includes(el.id));
                    }
                }
            }

            return collapsables.map(el => el.id);
        },
        ...mapGetters({
            // activeTab: 'activeTabKey',
            // tabs: 'currentTabs',

            form: 'ext_shop_categories/form',
            rules: 'ext_shop_categories/rules',
            validation: 'ext_shop_categories/validation',
            loading: 'ext_shop_categories/loading',

            options: 'ext_shop_categories/options',
            ui: 'ext_shop_categories/ui',
            // currentItem: 'ext_shop_categories/form/currentItem',

            initialized: 'ext_shop_categories/form_initialized',

            // cms
            activeCms: 'activeCms',
            enabledExtensions: 'enabledExtensions'
        })
    },
    methods: {
        forceCollapseAll() {
            if (this.ui.expandAll !== false) {
                this.collapseAll();
            } else {
                this.expandedKeys = [];
                this.expandAncestorCategories(this.$route.params.id);
                this.uniqid = uniqid(); // reload tree
            }
        },
        forceExpandAll() {
            if (this.ui.expandAll !== true) {
                this.expandAll();
            } else {
                this.expandedKeys = [];
                this.expandAncestorCategories(this.$route.params.id);
                this.uniqid = uniqid(); // reload tree
            }
        },
        initialize() {
            if (!this.activeCms.shop || !this.activeCms.shop.id) {
                this.error = true;
            } else if (this.initialized !== true) {
                this.setInitializedFlag(true);

                // const route = router.history.current.matched.find(route => route.components.default.name === 'Menu')
                // const key = _.get(route, 'meta.key')

                // const key = this.key

                this.error = false;

                // this.loading = true
                this.updateLoading(true);

                // this.updateItemTypeOptionsLoading(true)
                // this.updateSectionOptionsLoading(true)

                const fetchDependencies = () => {
                    return Promise.all([
                        // this.fetchCategoryOptions(this.activeCms.shop.id),
                    ]);
                };

                // fetch options for dropdowns
                fetchDependencies().catch(err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Category dependencies could not be fetched.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                });

                this.fetchCategories(this.activeCms.shop.id)
                    .catch(err => {
                        const { graphQLErrors } = err

                        let code = 501;
                        let message = 'An error occurred!';

                        if (graphQLErrors) {
                            code = _.get(graphQLErrors, '0.code') || code;
                            message = _.get(graphQLErrors, '0.message') || message;
                        } else {
                            add = false;
                            this.error = true;

                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);
                        }

                        switch (code) {
                            case 401:
                                this.error = { code, message: 'You are not authorized' };
                                break;
                            case 403:
                                this.error = { code, message: 'You are not allowed to be here' };
                                break;
                            default:
                                this.error = true;
                                break;
                        }
                    })
                    .then(() => {
                        // check if there are more items than 50
                        // and there are collapsables
                        // set ui.expandAll = false

                        const items = _.get(this.form, 'categories') || [];
                        if (this.ui.expandAll === false || items.length > 50 && this.collapsables.length) {
                            this.collapseAll();
                        }
                        this.expandAncestorCategories(this.$route.params.id);
                    })
                    .finally(() => {
                        this.updateLoading(false);
                    });
            } else {
                this.expandAncestorCategories(this.$route.params.id);
            }
        },
        expandAncestorCategories(id) {
            if (id) {
                // this.expandedKeys.push(id)

                const items = _.get(this.form, 'categories') || [];
                const item = items.find(el => el.id.toString() === id.toString());

                if (item) {
                    const ancestors = NestedSet.getAncestors(items, item);
                    ancestors.forEach(el => {
                        if (!this.expandedKeys.includes(el.id)) this.expandedKeys.push(el.id);
                    });

                    // if (ancestors && ancestors.length) {
                    //     this.expandedKeys.push(id)
                    // }
                }
            }
        },
        submit() {
            this.$refs.form.validate((valid, errors) => {
                if (valid) {
                    const itemID = this.$route.params.id;

                    let currentCategory = null;
                    if (itemID) {
                        currentCategory = _.get(this.form, 'categories', []).find(
                            item => item.id.toString() === itemID.toString()
                        );
                    }

                    this.saving = true;

                    let categories = _.cloneDeep(this.form.categories);
                    this.save({ shop: this.activeCms.shop.id, categories })
                        .then(data => {
                            let categories = _.cloneDeep(data);
                            if (currentCategory && currentCategory.key) {
                                // const route = router.history.current.matched.find(route => route.components.default.name === 'Menu')

                                let index = null;
                                if (_.startsWith(itemID, 'new:')) {
                                    index = _.findIndex(categories, item => item.key === currentCategory.key);
                                } else {
                                    index = _.findIndex(categories, item => item.id.toString() === itemID.toString());
                                }

                                let item = null;
                                if (index >= 0) item = categories[index];

                                if (item && item.id) {
                                    // in production gibt es an dieser Stelle einen Fehler ohne den Timeout.
                                    // Next Tick geth auch nicht
                                    // TODO: bessere Lösung finden
                                    setTimeout(() => {
                                        this.fetchCategory(item.id)
                                            .then(category => {
                                                if (category) categories[index] = category;
                                            })
                                            .catch(err => {
                                                /* eslint no-console: ["error", { allow: ["error"] }] */
                                                console.error(err);
                                                this.$notify.error({
                                                    title: this.$t('An error occurred!'),
                                                    message: this.$t('Category could not be fetched.'),
                                                    iconClass: 'fas el-icon-fa-xmark',
                                                    position: 'bottom-left',
                                                    customClass: 'dark',
                                                    duration: 8000
                                                });
                                            })
                                            .finally(() => {
                                                this.saving = false;
                                                store.commit('ext_shop_categories/insertCategories', categories);

                                                if (_.startsWith(itemID, 'new:')) {
                                                    this.$nextTick(() => {
                                                        // router.replace(`${route.path}/${item.id}`)
                                                        const params = { id: item.id };
                                                        router.replace({ name: 'category-form-item', params });
                                                    });
                                                }
                                            });
                                    }, 0);
                                } else {
                                    this.saving = false;

                                    store.commit('ext_shop_categories/insertCategories', categories);
                                    // this.$nextTick(() => {
                                    //     router.replace(`${route.path}`)
                                    // })
                                }
                            } else {
                                this.saving = false;
                                store.commit('ext_shop_categories/insertCategories', categories);
                            }

                            this.$notify.success({
                                title: this.$t('Categories saved successfully!'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        })
                        .catch(err => {
                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);

                            this.saving = false;

                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Categories could not be saved.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        });
                } else {
                    // TODO: show errors
                    // go to the next error if there is none on the current view
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(errors);
                }
            });
        },
        toggleExpand(node) {
            if (node.expanded && this.expandedKeys.includes(node.data.id)) {
                const index = this.expandedKeys.findIndex(el => el.toString() === node.data.id.toString());
                if (index >= 0) this.$delete(this.expandedKeys, index);

                // NOTE
                // workaround: delete also all children
                // don't put them back right after
                const items = _.get(this.form, 'categories', []);
                const children = NestedSet.getChildren(items, node.data).filter(el => el._rgt - el._lft > 1);
                children.forEach(child => {
                    const index = this.expandedKeys.findIndex(el => el.toString() === child.id.toString());
                    if (index >= 0) this.$delete(this.expandedKeys, index);
                });
            } else if (!node.expanded) {
                const index = this.expandedKeys.findIndex(el => el.toString() === node.data.id.toString());
                if (index < 0) this.expandedKeys.push(node.data.id);
            }

            this.$set(node, 'expanded', !node.expanded);
            this.expandAncestorCategories(this.$route.params.id);
        },
        openNewCategoryModal() {
            this.newCategoryModalLoading = true;
            this.newCategoryModalVisibility = true;

            const fetchOptions = () =>
                Promise.all([
                    // MenuApi.fetchItemPaths(this.activeCms.id, this.form.key)
                    //     .then(items => items.forEach(item => this.usedPaths.push(item.path))),
                ]);

            const defaultTarget = this.currentCategory || _.head(this.tree);
            this.newCategoryForm.target = _.get(defaultTarget, 'id');

            fetchOptions()
                .then(() => {
                    // TODO: rules

                    setTimeout(() => (this.newCategoryModalLoading = false), 0);
                })
                .catch(err => {
                    this.newCategoryModalVisibility = false;

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Category dependencies could not be fetched.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                });
        },
        appendCategory() {
            this.$refs.newCategoryForm.validate(valid => {
                if (valid) {
                    const id = uniqid('new:');
                    this.newCategoryForm.data.id = id;

                    this.addCategory(this.newCategoryForm);

                    this.changeCurrentCategory(this.newCategoryForm.data);
                    this.closeNewCategoryModal();
                }
            });
        },
        isDraggable(node) {
            return node.data.id !== '__orphans';
        },
        isDeletable(data) {
            return data.id !== '__orphans';
        },
        isOrphan(data) {
            const items = _.get(this.form, 'categories') || [];
            const ancestors = NestedSet.getAncestors(items, data).map(item => item.id);

            return data.id === '__orphans' || ancestors.includes('__orphans');
        },
        moveTreeItem(draggingNode, dropNode, position) {
            // console.log({ item: draggingNode.data, target: dropNode.data, position });
            // this.moveCategory({ item: draggingNode.data, target: dropNode.data, position });

            // console.log('>>>', this.tree[0].name)
            const tree = _.cloneDeep(this.tree)
            const items = NestedSet.flattenTree(tree)

            store.commit('ext_shop_categories/set', { path: 'form.categories', value: items })
        },
        hasDisabledAncestor(data) {
            const items = _.get(this.form, 'categories') || [];
            const deletedAncestors = NestedSet.getAncestors(items, data).filter(item => item.disabled);
            return deletedAncestors.length;
        },
        hasDeletedAncestor(data) {
            const items = _.get(this.form, 'categories') || [];
            const deletedAncestors = NestedSet.getAncestors(items, data).filter(item => item.deleted);
            return deletedAncestors.length;
        },
        resetNewCategoryModal() {
            this.$refs.newCategoryForm.resetFields();
            // this.newCategoryForm.data.component = null
            // this.newCategoryForm.target = null
        },
        closeNewCategoryModal() {
            this.newCategoryModalVisibility = false;
        },
        changeCurrentCategory(item) {
            if (item.id) {
                const params = { id: item.id };
                router.push({ name: 'category-form-item', params });
            }
        },
        ...mapMutations({
            setInitializedFlag: 'ext_shop_categories/form_initialized',

            updateLoading: 'ext_shop_categories/updateLoading',

            // updateItemTypeOptionsLoading: 'menu/updateItemTypeOptionsLoading',
            // insertItemTypeOptions: 'menu/insertItemTypeOptions',

            // updateSectionOptionsLoading: 'menu/updateSectionOptionsLoading',
            // insertSectionOptions: 'menu/insertSectionOptions',

            expandAll: 'ext_shop_categories/expandAll',
            collapseAll: 'ext_shop_categories/collapseAll',

            addCategory: 'ext_shop_categories/form/addCategory',
            moveCategory: 'ext_shop_categories/form/moveCategory',
            hideCategory: 'ext_shop_categories/form/markCategoryAsHidden',
            unhideCategory: 'ext_shop_categories/form/unmarkCategoryAsHidden',
            removeCategory: 'ext_shop_categories/form/markCategoryAsDeleted',
            restoreCategory: 'ext_shop_categories/form/unmarkCategoryAsDeleted'
            // setCurrentCategory: 'ext_shop_categories/form/setCurrentCategory'
        }),
        ...mapActions({
            // activateTab: 'activateTab',
            fetchCategories: 'ext_shop_categories/fetchCategories',
            fetchCategoryOptions: 'ext_shop_categories/fetchCategoryOptions',
            // fetchTagOptions: 'menu/fetchTagOptions',
            save: 'ext_shop_categories/save',
            fetchCategory: 'ext_shop_categories/fetchCategory'
            // fetchMenuItemPaths: 'menu/fetchMenuItemPaths',
        })
    },
    // beforeRouteEnter(to, from, next) {
    //     let cms = _.get(store, 'state.setup.activeCms')
    //     let menus = _.get(cms, 'config.template.menus') || []
    //     menus = _.orderBy(menus, 'position')

    //     const keys = _.map(menus, 'key')

    //     if (! keys.length) next({ name: 'dashboard' })
    //     else {
    //         // redirect if necessary
    //         let key = _.get(to, 'params.key')

    //         if (! key || key === '#' || ! keys.includes(key)) {
    //             key = keys[0]
    //             next({ name: 'menu-form', params: { key } })
    //         } else {
    //             next()
    //         }
    //     }
    // },
    beforeRouteUpdate(to, from, next) {
        if (to.name === 'category-form' || (to.name === 'category-form-item' && to.params.id === undefined)) {
            this.updateLoading(true);
            this.setInitializedFlag(false);
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        next();

        store.dispatch('ext_shop_categories/reset');
        store.commit('ext_shop_categories/resetUI');
        store.commit('ext_shop_categories/resetRules');
    },
    mounted() {
        this.initialize();
    }
};
</script>

<style lang="sass" scoped>
.category
    .el-card
        min-height: 125px
    ::v-deep .center-x-y.take-max-height section.has-text-centered
        .title
            font-size: 4rem
        .subtitle
            font-size: 1rem
            font-weight: normal

    .add-first-category
        margin-top: 20px

    .categories
        display: flex
        .content
            flex-basis: 100%
            flex-grow: 1
            padding-left: 20px
        .orphan
            color: $--color-warning

    .new-category-dialog ::v-deep .el-dialog
        max-width: 620px
        .modal-body > .el-form-item:last-child
            margin-bottom: 0
        .target-position
            display: flex
            .position
                padding-right: 10px
                flex-shrink: 0
                ::v-deep .el-switch
                    margin-top: -2px
                    position: relative
                    .el-switch__core
                        background-color: $--shop-color-primary
                    .el-switch__label
                        color: $--font-color-disabled-base
                        &.is-active
                            color: $--shop-color-primary
    .add-item
        margin-bottom: 1rem

    .context-icon
        font-size: 2.2rem
        text-align: center
        margin-bottom: 1rem
        color: $--shop-color-primary
        small
            font-size: 1rem
            display: block
</style>
